export default __webpack_public_path__ + "static/media/ic_optimism-1.8c824bcd.svg";